export const ReceiptClaimHeroImage = require('./receipt-claim-hero.jpg');
